import {
	clearSelectedAccountant,
	clearSelectedClient,
	clearSelectedTaxYear,
	setAppBarSelectedItem,
} from "../../../store/actions";

import { CompanyMenuComponent } from "./CompanyRoutes";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { PayrollRoutesComponent } from "./PayrollRoutes";
import { PeopleMenuComponent } from "./PeopleRoutes";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import { ReportsRoutesComponent } from "./ReportsRoutes";
import SettingsIcon from '@mui/icons-material/Settings';
import { SettingsRoutesComponent } from "./SettingsRoutes";
import { SlipsRoutesComponent } from "./SlipsRoutes";
import { TaxesRoutesComponent } from "./TaxesRoutes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export const AdminClientRoutesComponent = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { PeopleMenu } = PeopleMenuComponent();
	const { CompanyMenu } = CompanyMenuComponent();
	const { SlipsRoutes } = SlipsRoutesComponent();
	const { PayrollRoutes } = PayrollRoutesComponent();
	const { TaxesRoutes } = TaxesRoutesComponent();
	const { SettingsRoutes } = SettingsRoutesComponent();
	const { ReportsRoutes } = ReportsRoutesComponent();

	const clearClientId = () => {
		dispatch(clearSelectedClient());
	};
	const clearClientName = () => {
		// dispatch(clearSelectedClientName());
		dispatch(clearSelectedClient());
	};
	const clearAccountantId = () => {
		dispatch(clearSelectedAccountant());
	};
	const clearAccountantName = () => {
		// dispatch(clearSelectedAccountantName());
		dispatch(clearSelectedAccountant());
	};
	const clearTaxYear = () => {
		dispatch(clearSelectedTaxYear());
	};
	const goToAccList = () => {
		dispatch(setAppBarSelectedItem({ appBarSelectedItem: "Accountant" }))
	};
	const goToHome = () => {
		dispatch(setAppBarSelectedItem({ appBarSelectedItem: "Home" }))
	};
	const ArrayData: any = [
		{
			label: "Home",
			// icon: <HomeOutlinedIcon />,
			expanded: true,
			items: [
				{
					label: "Dashboard",
					command: () => {
						navigate("/clients/dashboard");
					},
				},
				{
					label: "Client List",
					command: () => {
						clearClientId();
						clearClientName();
						clearTaxYear();
						// clearRefNo();
						navigate("/clients");
					},
				},
				{
					label: "Super User",
					command: () => {
						clearClientId();
						clearClientName();
						clearAccountantId();
						clearAccountantName();
						clearTaxYear();
						goToAccList()
						// clearRefNo();
						navigate("/accountants");
					},
				},
				{
					label: "Global Search",
					command: () => {
						clearClientId();
						clearClientName();
						clearAccountantId();
						clearAccountantName();
						clearTaxYear();
						goToHome()
						// clearRefNo();
						navigate("/global-search");
					},
				},
			],
		},
		{
			label: "Company",
			// icon: <ContactMailOutlinedIcon />,
			items: CompanyMenu,
		},
		// {
		// 	label: "People",
		// 	icon: <ContactMailOutlinedIcon />,
		// 	items: PeopleMenu,
		// },
		{
			label: "Employee",
			// icon: <PermIdentityIcon />,
			items: [
				{
					label: "List",
					command: () => {
						navigate("/employee/list")
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/employee/setup")
					},
				},
				{
					label: "Bank",
					command: () => {
						navigate("/employee/bank-setup")
					},
				},
				{
					label: "Salary",
					command: () => {
						navigate("/employee/salary-profile")
					},
				},
				//   {
				// 	label: "Employee Status",
				// 	items: [
				// 	  {
				// 		label: "List",
				// 		command: () => {
				// 		  navigate("/employee/status/list")
				// 		},
				// 	  },
				// 	  {
				// 		label: "Setup",
				// 		command: () => {
				// 		  navigate("/employee/status/setup")
				// 		},
				// 	  },
				// 	],  
				//   },
				{
					label: "Status",
					command: () => {
						navigate("/employee/status")
					},
				},

				{
					label: "Assignment",
					command: () => {
						navigate("/employee/assignment")
					},
				},
				{
					label: "Import",
					command: () => {
						navigate("/employee/import")
					},
				},
				{
					label: "Draft",
					command: () => {
						navigate("/employee/draft")
					},
				},
				{
					label: "Payday Advance",
					command: () => {
						navigate("/employee/payday-advance")
					},
				},				
			],
		},
		{
			label: "Payroll",
			// icon: <DoneAllOutlinedIcon />,
			items: PayrollRoutes,
		},
		{
			label: "Taxes",
			// icon: <DoneAllOutlinedIcon />,
			items: TaxesRoutes,
		},
		{
			label: "Compliance",
			// icon: <DoneAllOutlinedIcon />,
			items: SlipsRoutes,
		},
		{
			label: "Reports",
			// icon: <DoneAllOutlinedIcon />,
			items: ReportsRoutes,
		},
		{
			label: "Settings",
			// icon: <SettingsIcon />,
			items: SettingsRoutes,
			hideLabel: true
		},

		// {
		// 	label: "Reports",
		// 	icon: <ListAltOutlinedIcon />,
		// 	items: [],
		// },
	];
	return {
		AdminClientRoutes: ArrayData,
	};
};
